// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4f62eef","453":"93409113","455":"7a7e1799","977":"36b399cc"}[chunkId] + ".chunk.js";
};